import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';

export const dashboardRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./pages/DashboardPage'), 'DashboardPage'),
});

export const dashboardRoutes = [dashboardRoute];
